export const CONTAINER_PRODUCT_ID = '5a1a172d-651c-4c76-a5ec-70543564372c';
